
namespace Serenity {

    export interface CardViewItemsProps<TItem> {
        items: TItem[];
        renderItem: (item: TItem, index: number) => React.ReactNode;
    }

    export class CardViewItems<TItem> extends React.Component<CardViewItemsProps<TItem>> {
        render(): React.ReactNode {
            return (
                <div className="card-items">
                    {this.props.items.map((item, index) =>
                        <div className="card-item" key={index}>
                            {this.props.renderItem(item, index)}
                        </div>
                    )}
                </div>
            );
        }
    }
}